import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, Image } from '../types'
import { ColumnsSpecialItemData } from './columns-special-item/columns-special-item.component.converter'
import { CmsConverterService, defaultFSCatalog } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ColumnsSpecialConverter extends CmsConverterService<ColumnsSpecialData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_title_text?.value
    const altText = formData.st_image_alternative_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      items: formData.st_items ?? defaultFSCatalog,
      image: CmsConverterService.mapImage(formData.st_image, lazyLoad, altText, title),
      showImage: formData.st_show_head_image?.value ?? false
    }
  }
}

export const COLUMNS_SPECIAL_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ColumnsSpecialData>>('ColumnsSpecialConverter')

export interface ColumnsSpecialData extends ConvertedComponentData {
  image: Image;
  items: FsCatalog<ColumnsSpecialItemData>;
  showImage: boolean;
}
